export default __webpack_public_path__ + "static/media/addi1.21d157d4.jpg";